import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0213afee&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0213afee')) {
      api.createRecord('0213afee', component.options)
    } else {
      api.reload('0213afee', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0213afee&", function () {
      api.rerender('0213afee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/system-maintenance/server-log/index.vue"
export default component.exports